import { Message } from "../../menu/message-box";
import { SideBattleMenu, BattleMenu } from "../../menu/battle/battle-menu";
import { SceneId } from "../../../shared/enum";
import { BattleScene } from "./side-battle-scene";
import { BattleParams } from "../../../shared/domain";

export class BattleUIScene extends Phaser.Scene {
    private message: Message;
    private battleMenu: BattleMenu;

    //    private battleScene: BattleScene;
    private callingScene: BattleScene;

    constructor() {
        super({ key: SceneId.BATTLE_MENU_SCENE });
    }

    preload() {}

    init(battleParams: BattleParams) {
        this.callingScene = battleParams.scene as BattleScene;
    }

    public create() {
        this.battleMenu = new SideBattleMenu(this);
        this.battleMenu.bindEvents();
        this.battleMenu.draw();

        // when the scene receives wake event (off-before-on prevents accumulation
        // if create() is ever called more than once without a full shutdown in between)
        this.sys.events.off("wake", this.refresh, this);
        this.sys.events.on("wake", this.refresh, this);

        this.refresh();

        // Signal battle_ready AFTER UI is fully initialized (menus drawn, events bound).
        // This prevents the server from sending player_input before the UI can handle it.
        this.battleMenu.signalReady();
    }

    public refresh() {
        this.battleMenu.process();
    }
}
